<template>
  <div class="dashboard-article-modal">
    <div class="dashboard-article-modal__card">
      <MVPArticlesForm
        :article="article"
        :articleKey="articleKey"
        :groups="groups"
        :stay-on-dashboard="stayOnDashboard"
        :can-renotify="canRenotify"
        @refresh="forwardRefresh"
        @close="closeModal"
      />
    </div>
  </div>
</template>

<script>
import MVPArticlesForm from '@/pages/News/Form.vue'

export default {
  name: 'DashboardArticleModal',
  components: {
    MVPArticlesForm
  },
  props: {
    article: {
      type: Object,
      default: null
    },
    articleKey: {
      type: [String, Number],
      default: null
    },
    groups: {
      type: Array,
      default: () => []
    },
    stayOnDashboard: {
      type: Boolean,
      default: false
    },
    canRenotify: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    forwardRefresh (...args) {
      this.$emit('refresh', ...args)
    },
    closeModal () {
      if (this.$parent && typeof this.$parent.close === 'function') {
        this.$parent.close()
      }
    }
  }
}
</script>
